import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ManPowerDto } from '../models/ManPowerDto';
import { ManpowerRequestVM } from '../models/requests/ManpowerRequestVM';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { approveManPowerVm } from '../models/approveManPowerVm';
import { ManpowerJDDto } from '../models/requests/ManpowerJDDto';
import { ManPowerPendingApprovalDto } from '../models/ManPowerPendingApprovalDto';
import { DateRangeRequest } from '../models/requests/DateRangeRequest';

@Injectable({
  providedIn: 'root'
})
export class ManPowersService {

  constructor(private httpClient: HttpClient) { }
  
  saveManPower(newManPowerRequest: ManpowerRequestVM): Observable<ApiResponseObject<ManPowerDto>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/Manpowers`, newManPowerRequest);
  }
  getManPower(): Observable<ApiResponseObject<ManPowerDto[]>> {
    ; 
   var result = this.httpClient.get<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/Manpowers/ViewMyMyManpowerRequests`);
   return result;
 }
 getManPowerbyId(id:number): Observable<ApiResponseObject<ManPowerDto>> {
    ; 
   var result = this.httpClient.get<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/Manpowers/RequestById/${id}`);
   return result;
 }

 
 getPendingRequestApprovals(id:number): Observable<ApiResponseObject<ManPowerPendingApprovalDto[]>> {
  ;
  return this.httpClient.get<ApiResponseObject<ManPowerPendingApprovalDto[]>>(`${environment.apiUrl}/Manpowers/GetApprovals/${id}`);
}

  getPendingManPower(): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/Manpowers/MyPendingRequests`);
  }

  
  getNewManPowerRequest(): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/Manpowers/MyNewRequests`);
  }

  



  approveManPower(approveManPowerRequest: approveManPowerVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Manpowers/Approve`, approveManPowerRequest);
  }

  
  rejectManPower(approveManPowerRequest: approveManPowerVm): Observable<ApiResponseObject<boolean>> {
   
    return this.httpClient.post<ApiResponseObject<boolean>>(`${environment.apiUrl}/Manpowers/Reject`, approveManPowerRequest);
  }

  fileExtention(name: any ) {
    ;
    const regex = /(?:\.([^.]+))?$/;
    return regex.exec(name)![1];
  }
  
  
  GetJDForRequest(ContractId:number): Observable<ApiResponseObject<ManpowerJDDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ManpowerJDDto[]>>(`${environment.apiUrl}/ManPowers/GetJDForRequest/${ContractId}`);
  }

  GetByLocation(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/RequestByLocation`, obj);
    //return this.httpClient.post<ApiResponseObject<MovementDto[]>>(`${environment.apiUrl}/MovementRequests/GetRequestByEmpDestinationLocation/${name}`);
  }
  
  GetByFunction(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/RequestByFunction`, obj);
  }
  
  GetByTypeOfVacancy(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/RequestTypeofVacancy`, obj);
  }

  onModeOfRecruitmentChange(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/RequestByModeOfRecruit`, obj);
  }

  GetByStatus(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/RequestByStatus`, obj);
  }
  getByDateRange(dateRangeRequest: DateRangeRequest): Observable<ApiResponseObject<ManPowerDto[]>> {
   
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/getByDateRange`, dateRangeRequest);
  }
  
  SendManualReminder(obj: any): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.post<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/ManPowers/SendManualReminder`, obj);
  }
  CancelRequest(data: any): Observable<ApiResponseObject<ManPowerDto>> {

    return this.httpClient.post<ApiResponseObject<ManPowerDto>>(`${environment.apiUrl}/ManPowers/CancelRequest`, data);
  }


  MyApprovedManpowerRequests(): Observable<ApiResponseObject<ManPowerDto[]>> {
    ;
    return this.httpClient.get<ApiResponseObject<ManPowerDto[]>>(`${environment.apiUrl}/Manpowers/MyApprovedManpowerRequests`);
  }


}


